<template>
  <v-dialog v-model="newUserDialog" max-width="1200px" persistent scrollable>
    <v-card style="border-radius: 10px" v-if="selectedItem != null">
      <v-toolbar
        dark
        style="background-color: #fddf00; color: black"
        class="elevation-0"
      >
        <v-toolbar-title><h4>Edit Commission Withdraw</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="$emit('setDialog', false)" color="black" size="30"
          >close</v-icon
        >
      </v-toolbar>

      <v-card-text style="height: auto;" class="px-4 pt-4">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-toolbar-title><h4>Manager Commission</h4> </v-toolbar-title>
          <v-container>
            <v-layout row wrap align-center>
              <v-autocomplete
                :rules="[(v) => !!v || 'Required']"
                outline
                :items="province_list"
                outlined
                :loading="loadingProvince"
                item-text="province_name_th"
                item-value="province_id"
                dense
                label="Province"
                class="mr-2"
                v-model="selectedItem.commission_withdraw_province.province_id"
                @change="
                  districtList = [];
                  getDistrictListChange();
                "
              >
              </v-autocomplete>
              <v-autocomplete
                :rules="[(v) => !!v || 'Required']"
                outline
                v-model="selectedItem.commission_withdraw_district.district_id"
                :items="DistrcitCommissionByid"
                outlined
                :loading="loadingProvince"
                item-text="district_name_th"
                item-value="district_id"
                dense
                label="District"
              ></v-autocomplete>
            </v-layout>
          </v-container>
          <v-container>
            <v-layout row wrap>
              <v-layout xs12 sm3>
                <v-toolbar-title style="margin-top:15px"
                  ><h4>Commission type :</h4>
                </v-toolbar-title>
              </v-layout>
              <v-layout xs12 sm9>
                <v-radio-group
                  v-model="selectedItem.commission_withdraw_type"
                  row
                  @change="changeType"
                >
                  <v-radio label="Credit" value="1" color="yellow"></v-radio>
                  <v-radio label="Percent" value="2" color="yellow"></v-radio>
                </v-radio-group>
              </v-layout>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
            </v-layout>

            <div v-if="selectedItem.commission_withdraw_type == '1'">
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-toolbar-title style="margin-top:35px"
                    ><h4>Commission unit :</h4>
                  </v-toolbar-title>
                </v-flex>
                <v-flex xs12 sm6 style="padding:20px">
                  <v-text-field
                    type="number"
                    :rules="[rules.required, rules.number, rules.counterMore]"
                    v-model="selectedItem.commission_withdraw_amount"
                    placeholder="Enter number"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-toolbar-title style="margin-top:35px"
                    ><h4>Credit</h4>
                  </v-toolbar-title>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-toolbar-title style="margin-top:35px"
                    ><h4>Maximum Commission :</h4>
                  </v-toolbar-title>
                </v-flex>
                <v-flex xs12 sm6 style="padding:16px">
                  <v-text-field
                    disabled
                    placeholder="Enter number"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-toolbar-title
                    ><h4 style="color:gray;margin-top: 35px;">Credit</h4>
                  </v-toolbar-title>
                </v-flex>
              </v-layout>
            </div>
            <div v-if="selectedItem.commission_withdraw_type == '2'">
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-toolbar-title style="margin-top:35px"
                    ><h4>Commission unit :</h4>
                  </v-toolbar-title>
                </v-flex>
                <v-flex xs12 sm6 style="padding:20px">
                  <v-text-field
                    type="number"
                    :rules="[rules.required, rules.counter, rules.number]"
                    v-model="selectedItem.commission_withdraw_amount"
                    placeholder="Enter number"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-toolbar-title style="margin-top:35px"
                    ><h4>%</h4>
                  </v-toolbar-title>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-toolbar-title style="margin-top:35px"
                    ><h4>Maximum Commission :</h4>
                  </v-toolbar-title>
                </v-flex>
                <v-flex xs12 sm6 style="padding:16px">
                  <v-text-field
                    type="number"
                    v-model="
                      selectedItem.commission_withdraw_commission_maximum
                    "
                    :rules="[rules.required, rules.number, rules.counterMore]"
                    placeholder="Enter number"
                    outline
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-toolbar-title style="margin-top:35px"
                    ><h4>Credit</h4>
                  </v-toolbar-title>
                </v-flex>
              </v-layout>
            </div>
          </v-container>
          <v-card-actions style="padding-bottom: 30px" class="pr-4">
            <v-spacer></v-spacer>
            <v-btn
              @click="editWithdraw"
              :loading="isAdding"
              dark
              color="black"
              style="
                  width: 120px;
                  background: #000000 0% 0% no-repeat padding-box;
                  box-shadow: 0px 3px 6px #00000029;
                  border-radius: 7px;
                  font-weight: bold;
                  letter-spacing: 0.1rem;
                "
              >CONFIRM</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import _ from "lodash";

let _this = this;
export default {
  props: ["newUserDialog", "selectedItem"],
  data() {
    return {
      valid: true,
      loadingProvince: false,
      districtList: [],
      isAdding: false,
      maximum: "Enter number",
      province: "",
      district: "",
      oldData: null,
      formCredit: {
        number: "",
      },
      formPercent: {
        unit: "",
        max: "",
      },
      radioGroup: "",
      rules: {
        counter: (value) => (value >= 1 && value <= 100) || "Min 1 or Max100",
        required: (value) => !!value || "Required.",
        number: (value) => {
          const pattern = /^[-+]?[0-9]+\.[0-9]+$/;
          return !pattern.test(value) || "Not Decimal";
        },
        counterMore: (value) => value >= 1 || "Min 1",
      },
    };
  },
  watch: {
    async newUserDialog() {
      if (this.newUserDialog == true) {
        this.loadingProvince = true;

        await this.getDistrictList();
        this.loadingProvince = false;
        this.oldData = this.selectedItem.commission_withdraw_commission_maximum;
      }
    },
    async radioGroup() {
      if (this.selectedItem.commission_withdraw_type == 1) {
        this.radioGroup = "Credit";
        this.selectedItem.commission_withdraw_commission_maximum = 0;
        this.formCredit = {
          number: "",
        };
      } else {
        this.radioGroup = "Percent";
        this.selectedItem.commission_withdraw_commission_maximum = "";
        this.formCredit = {
          number: "",
        };
      }
    },
  },
  computed: {
    ...mapState({
      district_list: (state) => state.fetchProvinceBack.district_list,
      DistrcitCommissionByid: (state) => state.fetchWithdraw.district,
    }),
    ...mapGetters({
      province_list: "fetchProvinceBack/provinceSplited",
    }),
  },
  methods: {
    ...mapActions({
      fetchDistrcitCommissionByid:
        "fetchWithdraw/fetchDistrcitCommissionWithdraw",
    }),

    async changeType() {
      if (this.selectedItem.commission_withdraw_type == 1) {
        this.selectedItem.commission_withdraw_commission_maximum = 0;
      } else {
        this.selectedItem.commission_withdraw_commission_maximum = this.oldData;
      }
    },

    async editWithdraw() {
      if (this.$refs.form.validate()) {
        let commissionWithdraw = {
          commission_withdraw_id: this.selectedItem.commission_withdraw_id,
          commission_withdraw_type: this.selectedItem.commission_withdraw_type,
          commission_withdraw_province_id: this.selectedItem
            .commission_withdraw_province.province_id,
          commission_withdraw_district_id: this.selectedItem
            .commission_withdraw_district.district_id,
          commission_withdraw_amount: this.selectedItem
            .commission_withdraw_amount,
          commission_withdraw_commission_maximun: this.selectedItem
            .commission_withdraw_commission_maximum,
        };
        this.isAdding = true;
        let _this = this;
        this.$emit("onSaved", {
          form: commissionWithdraw,
          done() {
            _this.isAdding = false;
          },
        });
      }
    },
    async changeType() {
      if (this.selectedItem.commission_withdraw_type == 1) {
        this.radioGroup = "Credit";
        this.selectedItem.commission_withdraw_commission_maximum = "";
        this.selectedItem.commission_withdraw_amount = "";
        this.$refs.form.resetValidation();
      } else {
        this.radioGroup = "Percent";
        this.selectedItem.commission_withdraw_commission_maximum = "";
        this.selectedItem.commission_withdraw_amount = "";
        this.$refs.form.resetValidation();
      }
    },
    async getDistrictList() {
      this.loadingDistrict = true;
      let selectdistrict = await this.fetchDistrcitCommissionByid({
        manager_id: this.selectedItem.commission_withdraw_province.province_id,
      });
      let select = {
        district_id: this.selectedItem.commission_withdraw_district.district_id,
        district_name_th: this.selectedItem.commission_withdraw_district
          .district_name_th,
      };
      selectdistrict.push(select);
      this.loadingDistrict = false;
    },
    async getDistrictListChange() {
      this.selectedItem.commission_withdraw_district.district_name_th = "";
      this.selectedItem.commission_withdraw_district.distrcit_name_en = "";
      this.selectedItem.commission_withdraw_district.district_id = "";
      this.loadingDistrict = true;
      await this.fetchDistrcitCommissionByid({
        manager_id: this.selectedItem.commission_withdraw_province.province_id,
      });
      this.loadingDistrict = false;
    },
    clear() {
      (this.formCredit = {
        number: "",
      }),
        (this.formPercent = {
          unit: "",
          max: "",
        }),
        (this.province = ""),
        (this.district = ""),
        (this.selectdistrict = false),
        this.$refs.form.resetValidation();
      this.radioGroup = "Credit";
    },
  },
};
</script>
